(() => {
  if (customElements.get('niwa-product-discovery')) return;
  const KEY='niwa-viewed-products-v1', TTL=30*24*60*60*1000;
  const root=window.Shopify?.routes?.root||'/';
  const escape=value=>String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeHistory=value=>Array.isArray(value)?value.filter(x=>x && /^\d+$/.test(String(x.id)) && typeof x.handle==='string' && x.handle.length<255 && Number.isFinite(x.at) && Date.now()-x.at<TTL && x.at<=Date.now()+60000).slice(0,20):[];
  let memory=[];
  function history() {try{return safeHistory(JSON.parse(localStorage.getItem(KEY)||'[]'));}catch(_){return memory;}}
  function save(items) {memory=items;try{localStorage.setItem(KEY,JSON.stringify(items));}catch(_) {}}
  async function htmlCards(url) {
    const response=await fetch(url,{credentials:'same-origin'});
    if(!response.ok)throw Error('商品を取得できませんでした。');
    return [...new DOMParser().parseFromString(await response.text(),'text/html').querySelectorAll('[data-discovery-feed] > [data-product-id]')];
  }
  class Discovery extends HTMLElement {
    connectedCallback() {
      if(this.dataset.ready)return;
      this.dataset.ready='true'; this.limit=Number(this.dataset.limit)||8;
      this.past=history().filter(x=>String(x.id)!==this.dataset.currentId);
      save([{id:this.dataset.currentId,handle:this.dataset.currentHandle,at:Date.now()},...this.past].slice(0,20));
      this.loaded=new Set(); this.loading=new Map(); this.historyVersion=0;
      this.buttons=[...this.querySelectorAll('[data-tab]')];
      this.buttons.forEach((button,index)=>{
        button.addEventListener('click',()=>this.activate(button.dataset.tab));
        button.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%this.buttons.length;
          if(event.key==='ArrowLeft')next=(index+this.buttons.length-1)%this.buttons.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=this.buttons.length-1;
          if(next!==undefined){event.preventDefault();this.buttons[next].focus();this.activate(this.buttons[next].dataset.tab);}
        });
      });
      this.querySelector('[data-clear-history]').addEventListener('click',()=>{
        save([]);this.past=[];this.historyVersion++;
        this.loading.delete('history');this.loading.delete('personal');
        this.loaded.delete('history');this.loaded.delete('personal');
        this.showCards('history',[],'閲覧履歴を削除しました。');
        this.load('personal');
      });
      this.activate('new');
    }
    activate(key) {
      this.buttons.forEach(button=>{const active=button.dataset.tab===key;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;});
      this.querySelectorAll('[data-panel]').forEach(panel=>panel.hidden=panel.dataset.panel!==key);
      this.load(key);
    }
    panel(key){return this.querySelector(`[data-panel="${key}"]`);}
    showCards(key,cards,empty) {
      const panel=this.panel(key),grid=panel.querySelector('[data-grid]');
      grid.replaceChildren(...cards.slice(0,this.limit));
      const status=panel.querySelector('[data-status]');
      status.textContent=cards.length?'':empty;status.hidden=cards.length>0;
    }
    load(key) {
      if(this.loaded.has(key))return Promise.resolve();
      if(this.loading.has(key))return this.loading.get(key);
      const task=this.fetchPanel(key).then(()=>this.loaded.add(key)).catch(()=>{
        const status=this.panel(key).querySelector('[data-status]');
        status.hidden=false;status.textContent='商品を読み込めませんでした。再度タブを選択してお試しください。';
      }).finally(()=>{if(this.loading.get(key)===task)this.loading.delete(key);});
      this.loading.set(key,task);return task;
    }
    async fetchPanel(key) {
      const exclude=cards=>cards.filter(card=>card.dataset.productId!==this.dataset.currentId);
      if(key==='ranking') {
        const panel=this.panel(key);
        [...panel.querySelectorAll('[data-grid] > li')].slice(this.limit).forEach(card=>card.remove());
        const count=panel.querySelectorAll('[data-grid] > li').length;
        panel.querySelector('[data-status]').textContent=count?'':'ランキング商品は準備中です。';
        panel.querySelector('[data-status]').hidden=count>0;return;
      }
      if(key==='new'||key==='pickup') {
        const count=Number(this.dataset.count)||1;
        const page=key==='pickup'?Math.floor(Math.floor(Math.random()*count)/50)+1:1;
        const url=new URL(root+'collections/all',location.origin);
        url.searchParams.set('section_id','niwa-discovery-feed');
        url.searchParams.set('sort_by','created-descending');url.searchParams.set('page',page);
        let cards=exclude(await htmlCards(url));
        if(key==='pickup')for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
        this.showCards(key,cards,'現在表示できる商品はありません。');return;
      }
      if(key==='history') {
        const version=this.historyVersion;
        const results=await Promise.allSettled(this.past.slice(0,this.limit).map(async item=>{
          const response=await fetch(root+'products/'+encodeURIComponent(item.handle)+'.js',{credentials:'same-origin'});
          if(!response.ok)throw Error('unavailable');
          const product=await response.json();
          const li=document.createElement('li');li.className='niwa-discovery__item';li.dataset.productId=String(product.id);li.dataset.handle=product.handle;
          const price=new Intl.NumberFormat('ja-JP',{style:'currency',currency:window.Shopify?.currency?.active||'JPY'}).format(product.price/100);
          const image=typeof product.featured_image==='string'?product.featured_image:product.featured_image?.src;
          li.innerHTML=`<a href="${escape(root+'products/'+encodeURIComponent(product.handle))}"><div class="niwa-discovery__image">${image?`<img src="${escape(image)}" alt="${escape(product.title)}" loading="lazy" width="360" height="360">`:'<span>画像準備中</span>'}</div><h3>${escape(product.title)}</h3><p>${escape(price)}${product.price_varies?'〜':''}<small>税込・送料別${product.available?'':' · 売り切れ'}</small></p></a>`;
          return li;
        }));
        if(version!==this.historyVersion)return;
        this.showCards(key,results.filter(r=>r.status==='fulfilled').map(r=>r.value),'ほかの商品を見ると、ここに閲覧履歴が表示されます。');return;
      }
      if(key==='personal') {
        const version=this.historyVersion;
        const seeds=this.past.length?this.past.slice(0,3):[{id:this.dataset.currentId}];
        const note=this.panel(key).querySelector('[data-note]');
        note.textContent=this.past.length?'最近閲覧した商品とShopifyの関連商品情報をもとに選んでいます。':'閲覧履歴がまだないため、いま見ている商品に関連する商品を表示します。';
        const results=await Promise.allSettled(seeds.map(seed=>{
          const url=new URL(root+'recommendations/products',location.origin);
          url.searchParams.set('section_id','niwa-discovery-feed');url.searchParams.set('product_id',seed.id);
          url.searchParams.set('limit','10');url.searchParams.set('intent','related');return htmlCards(url);
        }));
        if(version!==this.historyVersion)return;
        if(results.every(r=>r.status==='rejected'))throw Error('recommendations');
        const scores=new Map();
        results.forEach((result,seedIndex)=>{if(result.status!=='fulfilled')return;exclude(result.value).forEach((card,index)=>{
          const id=card.dataset.productId,entry=scores.get(id)||{card,score:0};entry.score+=1/((seedIndex+1)*(index+1));scores.set(id,entry);
        });});
        this.showCards(key,[...scores.values()].sort((a,b)=>b.score-a.score).map(x=>x.card),'関連するおすすめ商品は現在準備中です。');
      }
    }
  }
  customElements.define('niwa-product-discovery',Discovery);
})();

